// Select the countdown timer elements
const daysLabel = document.getElementById("days");
const hoursLabel = document.getElementById("hours");
const minutesLabel = document.getElementById("minutes");
const secondsLabel = document.getElementById("seconds");

const targetDate = new Date("December 9, 2025 17:00:00").getTime();

let countdownInterval;

function initializeCountdown() {
    if (!daysLabel || !hoursLabel || !minutesLabel || !secondsLabel) {
        console.error("Countdown elements not found");
        return;
    }
    
    setTime();
    countdownInterval = setInterval(setTime, 1000);
}

function setTime() {
    const now = new Date().getTime();
    const distance = targetDate - now;

    if (distance < 0) {
        if (countdownInterval) {
            clearInterval(countdownInterval);
            countdownInterval = null;
        }
        daysLabel.innerHTML = "00";
        hoursLabel.innerHTML = "00";
        minutesLabel.innerHTML = "00";
        secondsLabel.innerHTML = "00";
        
        const eventMessage = document.createElement("div");
        eventMessage.className = "text-center text-amber-600 font-bold mt-4";
        eventMessage.innerHTML = "🎉 The wedding day has arrived!";
        daysLabel.parentElement.appendChild(eventMessage);
        return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    daysLabel.innerHTML = pad(days);
    hoursLabel.innerHTML = pad(hours);
    minutesLabel.innerHTML = pad(minutes);
    secondsLabel.innerHTML = pad(seconds);
}

function pad(val) {
    const valString = val.toString();
    return valString.length < 2 ? "0" + valString : valString;
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCountdown);
} else {
    initializeCountdown();
}

// Cleanup on page unload
window.addEventListener('beforeunload', () => {
    if (countdownInterval) {
        clearInterval(countdownInterval);
    }
});
